const DB = "linguapath-offline";
const STORES = ["lessons", "quizzes", "audio", "meta", "queue"];
let dbp;

function open() {
  if (!dbp)
    dbp = new Promise((resolve, reject) => {
      const r = indexedDB.open(DB, 1);
      r.onupgradeneeded = () =>
        STORES.forEach((s) => {
          if (!r.result.objectStoreNames.contains(s))
            r.result.createObjectStore(s, s === "queue" ? { keyPath: "id", autoIncrement: true } : undefined);
        });
      r.onsuccess = () => resolve(r.result);
      r.onerror = () => reject(r.error);
    });
  return dbp;
}

async function run(store, mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const req = fn(t.objectStore(store));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
}

export const idb = {
  get: (s, k) => run(s, "readonly", (st) => st.get(k)),
  set: (s, k, v) => run(s, "readwrite", (st) => (k == null ? st.put(v) : st.put(v, k))),
  del: (s, k) => run(s, "readwrite", (st) => st.delete(k)),
  all: (s) => run(s, "readonly", (st) => st.getAll()),
  keys: (s) => run(s, "readonly", (st) => st.getAllKeys()),
  clear: (s) => run(s, "readwrite", (st) => st.clear()),
};
